// extracted by mini-css-extract-plugin
export var container = "searchBoxMobile-module--container--E-Tkk";
export var input = "searchBoxMobile-module--input--89euc";
export var open = "searchBoxMobile-module--open--7uxDo";
export var search = "searchBoxMobile-module--search--Ef8T2";